export const MIN_QUERY_LENGTH = 2
export const MAX_QUERY_LENGTH = 200
